import React from 'react';
import {Link} from 'react-router-dom'
import {connect} from 'react-redux';
import TextField from '@material-ui/core/TextField';
import IconButton from '@material-ui/core/IconButton';
import Button from '@material-ui/core/Button';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import IntlMessages from 'util/IntlMessages';
import CircularProgress from '@material-ui/core/CircularProgress';

class ForgotPasswod extends React.Component {
    constructor() {
        super();
        this.state = {
            email: ''
        }
    }

    componentDidUpdate() {

    }

    render() {
        
        return (
            <div
                 className="app-login-container d-flex justify-content-center align-items-center animated slideInUpTiny animation-duration-3">
                    <div className="login-content">
                        {/* <div className="login-header">
                            <Link className="app-logo" to="/" title="Jambo">
                                <img src="https://via.placeholder.com/177x65" alt="jambo" title="jambo"/>
                            </Link>
                        </div> */}

                        <div className="mb-4">
                            <h2 style={{textAlign: 'center'}}><IntlMessages id="appModule.forgotPassword"/></h2>
                        </div>

                        <div className="login-form">
                            <form method="post" action="/">
                                <div className="form-group mb-3">
                                    <TextField
                                        fullWidth
                                        id="outlined-name"
                                        label="Email"
                                        type="email"
                                        variant="outlined"
                                        onChange={(event) => this.setState({email: event.target.value})}
                                    />
                                </div>

                                <p>
                                    <IntlMessages id="appModule.dntRememberEmail"/> &nbsp;
                                    <a className="small" href="javascript:void(0)">
                                        <IntlMessages id="appModule.contactSupport"/>
                                    </a>
                                </p>

                                <div className="">
                                    <Link to="/" className="btn btn-primary jr-btn-rounded"><IntlMessages
                                        id="appModule.resetPassword"/></Link>
                                </div>
                            </form>
                        </div>
                    </div>
                
                {/* {
                    loader &&
                    <div className="loader-view">
                        <CircularProgress/>
                    </div>
                }
                {showMessage && NotificationManager.error(alertMessage)}
                <NotificationContainer/> */}
            </div>
        );
    }
}

const mapStateToProps = ({}) => {
    
};

export default connect(mapStateToProps, {
    
})(ForgotPasswod);



// WEBPACK FOOTER //
// ./containers/ForgotPassword.js